import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const ButtonSelector = ({ className, ...rest }) => {
  return (
    <button {...rest} type="button" className={classNames(className, 'ButtonSelector btn btn-default sans-serif')} />
  );
};

ButtonSelector.propTypes = {
  className: PropTypes.string
};
